// tip-api — 文章打赏(2026-06-12 spec §4.2)
//
// 路由:POST /gapi/user/articles/{article_id}/tip  {amount_coin}
// 错误:INSUFFICIENT_BALANCE → 弹层内提示并引导 /wallet/recharge

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@dogdisk/shared'

export type TipResult = { tip_id: string; amount_coin: number; tip_count: number }

export function useTipArticle(articleId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (amountCoin: number) =>
      apiClient.post<TipResult>(
        `/gapi/user/articles/${encodeURIComponent(articleId)}/tip`,
        { amount_coin: amountCoin },
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['social', 'stats', 'article', articleId] })
      void qc.invalidateQueries({ queryKey: ['wallet'] })
    },
  })
}
